import { default as worktime } from './worktime/routes'
import { default as category } from './category/routes'

export default [
    ...worktime,
    ...category,
]